import { apiClient } from "./apiClient";

export const crmSurveyFormQuestionApi = {
    selectAll: () => apiClient.get(`crm_survey_form_question`),
    select_datasource: (id: number, dm_coso_id: number,fieldValue:number) => apiClient.get(`crm_survey_form_question/datasource/${id}/coso/${dm_coso_id}/fieldValue/${fieldValue}`),
}